import React, { Component } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Button as AButton } from "antd";
import styles from "./index.scss";

export default class Button extends Component {
	static propTypes = {
		onClick: PropTypes.func,
		style: PropTypes.object,
		children: PropTypes.node,
		variant: PropTypes.string,
		type: PropTypes.string,
		className: PropTypes.string,
		label: PropTypes.string,
		size: PropTypes.string,
		width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
		height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
		disabledClassName: PropTypes.string,
		disableRipple: PropTypes.bool,
		disabled: PropTypes.bool,
		noShadow: PropTypes.bool,
		loading: PropTypes.bool,
		icon: PropTypes.any,
		block: PropTypes.bool,
	};

	static defaultProps = {
		className: "",
		label: "",
		size: "",
		variant: "",
		disabled: false,
		noShadow: false,
		disabledClassName: "",
		loading: false,
	};

	handleButtonClick = (event) => {
		const { onClick, disabled } = this.props;

		if (disabled) return;
		/*
            Do something before click event is passed to business logic
            like tracking for analytics
        */
		onClick &&
			onClick({
				event,
			});
	};

	renderChildren = () => {
		const { label, children } = this.props;

		if (label) return label;
		else return children;
	};

	render() {
		const {
			className,
			style,
			size,
			variant,
			noShadow,
			type,
			disabled,
			disableRipple,
			disabledClassName,
			loading,
			icon,
			block,
		} = this.props;

		const _props = {
			onClick: this.props.onClick,
			className,
			disabled,
			type,
			size,
			variant,
			block,
		};

		const _className = cx(
			className,
			styles[size],
			styles.button,
			{ [styles.ripple]: !disableRipple },
			{ [styles.shadow]: !noShadow },
			styles[variant],
			{
				[styles.disabled]: disabled,
				[disabledClassName]: disabled,
			}
		);

		return (
			<div
				style={style}
				onClick={() => this.handleButtonClick}
				className={_className}
			>
				<AButton
					loading={loading}
					icon={icon}
					type={this.props.variant}
					{..._props}
				>
					{this.renderChildren()}
				</AButton>
			</div>
		);
	}
}
